import {
  Alert,
  AlertTitle,
  Avatar,
  Box,
  Button,
  Collapse,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
  Snackbar,
} from "@mui/material";
import { DataGrid, GridToolbar, GridFilterPanel } from "@mui/x-data-grid";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import S3 from "react-aws-s3";
import { Buffer } from "buffer";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import AppContext from "../context/AppContext";

window.Buffer = window.Buffer || Buffer;

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      "& .MuiAlert-message": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      },
    },
  })
);
const UserManagement = () => {



  const config = {
    bucketName: "coredata-content",
    region: "ap-southeast-1",
    accessKeyId: "AKIA5WK6NVEA76RXRMQ3",
    secretAccessKey: "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",
  };
  const ReactS3Client = new S3(config);

  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    photo_url: "",
    email_verified: "",
    disabled: "",
    role: "",
  });
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  // const [open, setOpen] = useState(false);

  const [users, setUsers] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalUpdate, setOpenModalUpdate] = useState(false);
  const [openModalAdd, setopenModalAdd] = useState(false);
  const [addUser, setAdduser] = useState();
  const [email, getEmails] = useState([]);
  const [deleteemail, setDeleteEmails] = useState([]);
  const [error, setError] = useState("");
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [loadingUser, setLoadingUser] = useState(false);
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [currentEmail, setcurrentEmail] = useState({
    id: "",
    value: "",
  });
  const [new_email, setnewEmail] = useState("");
  const [new_emailAdd, setnewEmailAdd] = useState("");
  const { userRole } = useContext(AppContext);
  const storedUserRole = localStorage.getItem('userRole');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const handleFileChange = (e) => {
    setData({ ...data, photo_url: e.target.files[0] });
  };

  const handleAddUser = async () => {
    try {
      let url = "";
      if (data.photo_url == "") url = "";
      else
        url = await ReactS3Client.uploadFile(
          data.photo_url,
          data.photo_url.name
        );
      // const response = await axios.get(`${process.env.REACT_APP_CORE_URL}/api/sign_up`);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/sign_up`,
        {
          email: data?.email,
          email_verified: "true",
          password: data?.password,
          display_name: data?.name,
          phone_number: `+91${data?.phone}`,
          disabled: "false",
          photo_url: url ? url.location : "",
          role: data?.role,
        }
      );
      if (response.data.status == "success") {
        setAdduser(response.data.message);
        setMessage(response.data.message);
        setSeverity("success");
        setOpen(true);
        setOpenModal(false);
        setData({
          name: "",
          email: "",
          password: "",
          phone: "",
          photo_url: "",
          email_verified: "",
          disabled: "",
          role: "",
        });
      } else {
        setMessage(response.data.message);
        setSeverity("warning");
        setOpen(true);
      }

    } catch (err) {
      setMessage(error.response.data.error || "Failed to add category");
      setSeverity("error");
      setOpen(true);
      console.log(err);
    }
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     setOpen(false);
  //   }, 5000);
  // }, [open]);

  useEffect(() => {
    const fetchData = async () => {
      // const response = await axios.get(`${process.env.REACT_APP_CORE_URL}/api/user_details`);
      try {
        setLoadingUser(true)
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/user_details`
        );
        if (response.data.status == "success") {
          console.log(response.data.message);
          const filteredResponse = response.data.message.filter(
            (data) => data.role == storedUserRole
          );
          setUsers(filteredResponse);
          setLoadingUser(false)

        }
      } catch (err) {
        setMessage(error.response.data.error || "Failed to add category");
        setSeverity("error");
        setOpen(true);
        console.log(err);
      }
    };
    fetchData();
  }, [addUser]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoadingEmail(true)

      try {
        // const response = await axios.get(`${process.env.REACT_APP_CORE_URL}/api/user_details`);
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/report/get/emails`
        );
        if (response.data.status == "success") {
          getEmails(response.data.emails);
          setLoadingEmail(false)
        }
      } catch (err) {
        console.log(err);
        setMessage(error.response.data.error || "Failed to add category");
        setSeverity("error");
        setOpen(true);
      }
    };
    fetchData();
  }, [deleteemail, openModalUpdate, openModalAdd]);

  const handleAddDeviceModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const columns = [
    {
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"SL. No"}</strong>
      ),
      headerAlign: "center",
      align: "center",
      filterable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },

    {
      field: "photo_url",
      headerName: "photo_url",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Photo"}</strong>
      ),
      renderCell: (params) => {
        return <Avatar src={params.row.photo_url} />;
      },
    },

    {
      field: "display_name",
      headerName: "display_name",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Name"}</strong>
      ),
    },

    {
      field: "email",
      headerName: "Email",
      width: 220,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Email"}</strong>
      ),
    },
    {
      field: "creation_time",
      headerName: "creation_time",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Created At "}</strong>
      ),
    },
    {
      field: "last_login_time",
      headerName: "Last Login",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Last Login"}</strong>
      ),
    },
    {
      field: "last_refresh_time",
      headerName: "last_refresh_time",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Last Refreshed"}
        </strong>
      ),
    },

    {
      field: "email_verified",
      headerName: "email_verified",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Email Verified"}
        </strong>
      ),
    },
    {
      field: "role",
      headerName: "email_verified",
      width: 120,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Role"}</strong>
      ),
    },
  ];

  const handleUpdateModal = (row, id) => {
    setcurrentEmail({
      id: id,
      value: row,
    });
    setOpenModalUpdate(true);
  };
  const handleCloseModalUpdate = (row) => {
    setOpenModalUpdate(false);
  };
  const handleDelete = async (delete_id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_URL}/api/v1/report/delete/email`,
        {
          data: {
            email_id: delete_id,
          },
        }
      );
      setDeleteEmails(response.data.message);
      setError(response.data.message);
      setOpen(true);
      setMessage(response.data.message);
      setSeverity("success");
    } catch (err) {
      setError("some error occured, please Try again");
      setOpen(true);
      setMessage(error.response.data.error || "Failed to add category");
      setSeverity("error");
    }
  };

  const usercolumns = [
    {
      field: "id",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"SL. No"}</strong>
      ),
      headerAlign: "center",
      align: "center",
      filterable: false,
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },

    {
      field: "value",
      width: 310,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Email"}</strong>
      ),
      renderCell: (params) => {
        return <Typography id={params.id}>{params.value}</Typography>;
      },
    },
    {
      field: "updateButton",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}></strong>
      ),
      renderCell: (params) => (
        <Button
          variant="contained"
          style={{ borderRadius: 25, fontSize: 11, backgroundColor: storedUserRole == 'demo' ? 'grey' : '' }}
          id={params.row.updateButton}
          onClick={() => storedUserRole == 'demo' ? '' : handleUpdateModal(params.row.value, params.row.id)}
        >
          Update
        </Button>
      ),
    },
    {
      field: "deleteButton",
      width: 110,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}></strong>
      ),
      renderCell: (params) => (
        <Button
          variant="contained"
          style={{ borderRadius: 25, fontSize: 11, backgroundColor: storedUserRole == 'demo' ? 'grey' : '' }}
          id={params.row.deleteButton}
          onClick={() => storedUserRole == 'demo' ? '' : handleDelete(params.row.id)}
        >
          Delete
        </Button>
      ),
    },
  ];

  const handleUpdateButton = async (id) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/v1/report/update/email`,
        {
          email_id: id,
          new_email: new_email,
        }
      );

      setError(response.data.message);
      setOpen(true);
      setMessage(response.data.message);
      setSeverity("success");
      setOpenModalUpdate(false);
    } catch (err) {
      setMessage(error.response.data.error || "Failed to add category");
      setSeverity("error");
      setError("some error occured, please Try again");
      setOpen(true);
      setOpenModalUpdate(false);
    }
  };

  const handleAddButton = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/v1/report/add/email`,
        {
          email: new_emailAdd,
        }
      );
      setMessage(response.data.message);
      setSeverity("success");
      setError(response.data.message);
      setOpen(true);
      setopenModalAdd(false);
      setnewEmailAdd("");
    } catch (err) {
      console.log(err);
      setMessage(error.response.data.error || "Failed to add category");
      setSeverity("error");
      setError("some error occured, please Try again");
      setOpen(true);
      setopenModalAdd(false);
      setnewEmailAdd("");
    }
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Button
            variant="contained"
            style={{ marginBottom: 16, borderRadius: 25, fontSize: 11, backgroundColor: storedUserRole == 'demo' ? 'grey' : '' }}
            onClick={storedUserRole == 'demo' ? () => '' : handleAddDeviceModal}
          >
            Register User
          </Button>
          <DataGrid
            getRowId={(row) => row.email}
            rows={users}
            columns={columns}
            style={{ minHeight: 200 }}
            loading={loadingUser}
            rowSelection={false}
            pageSize={10}
            rowsPerPageOptions={[10, 20, 30]}
            components={{
              Toolbar: GridToolbar,
              FilterPanel: GridFilterPanel,
            }}
            slotProps={{
              filterPanel: {
                sx: {
                  width: "100%",          // full width responsive
                  maxWidth: "100%",
                  padding: "10px",
                  "& .MuiDataGrid-filterForm": {
                    flexDirection: "column",
                    gap: "10px",
                  },
                },
              },
            }}
            pagination
          />
          <Modal
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",

                width: isMobile ? 300 : 600,
                maxHeight: "100%",

                overflowY: "auto",
                overflowX: "auto",
                backgroundColor: "white",
                boxShadow: 24,
                padding: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "baseline",
                  justifyContent: "flex-end",
                  cursor: "pointer",
                  padding: "20px",
                }}
                onClick={handleCloseModal}
              >
                <img style={{ width: 20, height: 20 }} src="/Close.png" />
              </div>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "80%",
                  margin: "auto",
                }}
              >
                {/* <FormControl
                                className="shadow-lg p-5  bg-body rounded"
                                margin="normal"
                                variant="outlined"
                                fullWidth={true}
                                sx={{ gap: 2 }}
                            > */}
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      required
                      label="Name"
                      name="name"
                      value={data.name}
                      onChange={(e) => handleChange(e)}
                      style={{ width: isMobile ? 200 : "" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      required
                      label="Email"
                      name="email"
                      value={data.email}
                      onChange={(e) => handleChange(e)}
                      style={{ width: isMobile ? 200 : "" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      required
                      label="Password"
                      type="password"
                      name="password"
                      value={data.password}
                      onChange={(e) => handleChange(e)}
                      style={{ width: isMobile ? 200 : "" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      required
                      label="Phone Number"
                      name="phone"
                      value={data.phone}
                      onChange={(e) => handleChange(e)}
                      style={{ width: isMobile ? 200 : "" }}
                    />
                  </Grid>
                </Grid>

                {/* </FormControl> */}
                {/* <FormControl
                  className="shadow-lg p-5  bg-body rounded"
                  margin="normal"
                  variant="outlined"
                  fullWidth={true}
                  sx={{ gap: 2 }}
                >
                  <InputLabel id="demo-select-small-label">
                    Email Verified
                  </InputLabel>

                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    label="Email Verified"
                    name="email_verified"
                    value={data.email_verified}
                    onChange={(e) => handleChange(e)}
                    style={{ width: 445 }}
                  >
                    <MenuItem value="true">True</MenuItem>
                    <MenuItem value="false">False</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  className="shadow-lg p-5  bg-body rounded"
                  margin="normal"
                  variant="outlined"
                  fullWidth={true}
                  sx={{ gap: 2 }}
                >
                  <InputLabel id="demo-select-small-label">Disabled</InputLabel>

                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    label="Disabled"
                    name="disabled"
                    value={data.disabled}
                    onChange={(e) => handleChange(e)}
                    style={{ width: 445 }}
                  >
                    <MenuItem value="true">True</MenuItem>
                    <MenuItem value="false">False</MenuItem>
                  </Select>
                </FormControl> */}
                {userRole == "napino" ? (
                  <FormControl
                    className="shadow-lg p-5  bg-body rounded"
                    margin="normal"
                    variant="outlined"
                    fullWidth={true}
                    sx={{ gap: 2 }}
                  >
                    <InputLabel id="demo-select-small-label">Role</InputLabel>

                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      label="Role"
                      name="role"
                      value={data.role}
                      onChange={(e) => handleChange(e)}
                      style={{ width: isMobile ? 200 : 445 }}
                    >
                      <MenuItem value="napino">Napino</MenuItem>
                    </Select>
                  </FormControl>
                ) : (
                  <FormControl
                    className="shadow-lg p-5  bg-body rounded"
                    margin="normal"
                    variant="outlined"
                    fullWidth={true}
                    sx={{ gap: 2 }}
                  >
                    <InputLabel id="demo-select-small-label">Role</InputLabel>

                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      label="Role"
                      name="role"
                      value={data.role}
                      onChange={(e) => handleChange(e)}
                      style={{ width: isMobile ? 200 : 445 }}
                    >
                      <MenuItem value="admin">Admin</MenuItem>
                      <MenuItem value="superAdmin">Super Admin</MenuItem>
                    </Select>
                  </FormControl>
                )}
                {/* <FormControl
                  className="shadow-lg p-5  bg-body rounded"
                  margin="normal"
                  variant="outlined"
                  fullWidth={true}
                  sx={{ gap: 2 }}
                >
                  <InputLabel id="demo-select-small-label">Role</InputLabel>

                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    label="Role"
                    name="role"
                    value={data.role}
                    onChange={(e) => handleChange(e)}
                    style={{ width: 445 }}
                  > 
                    {
                       userRole == 'napino' ? 
                       <MenuItem value="napino">Napino</MenuItem>
: <>
                       <MenuItem value="admin">Admin</MenuItem>
                    <MenuItem value="superAdmin">Super Admin</MenuItem></>
                    }
                    
                  </Select>
                </FormControl> */}
                <FormControl
                  className="shadow-lg p-5  bg-body rounded"
                  margin="normal"
                  variant="outlined"
                  fullWidth={true}
                  sx={{ gap: 2 }}
                >
                  <input
                    id="file-input"
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    style={{
                      display: "none",
                    }}
                    onChange={handleFileChange}
                  />
                  <label htmlFor="file-input">
                    <Button
                      style={{
                        flexDirection: "column",
                        width: isMobile ? 200 : "50%",
                        margin: "auto",
                        marginRight: 20,
                      }}
                      variant="contained"
                      color="primary"
                      component="span"
                    >
                      {data.photo_url ? "Selected" : " Select Photo"}
                    </Button>
                    {data.photo_url ? data.photo_url.name : ""}
                  </label>
                </FormControl>
                <Button variant="contained" onClick={handleAddUser}>
                  Register
                </Button>
              </Box>
            </div>
          </Modal>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 40 }}>

          {
            storedUserRole != 'demo' &&
            <>
              <Button
                variant="contained"
                style={{ marginBottom: 16, borderRadius: 25, fontSize: 11, backgroundColor: storedUserRole == 'demo' ? 'grey' : '' }}
                onClick={() => storedUserRole == 'demo' ? '' : setopenModalAdd(true)}
              >
                Add Report Subscriber
              </Button>
              <DataGrid
                getRowId={(row) => row.value}
                rows={email.map((address, index) => ({
                  id: address.id,
                  value: address.email,
                  updateButton: `update-${index}`,
                  deleteButton: `delete-${index}`,
                }))}
                columns={usercolumns}
                pageSize={10}
                loading={loadingEmail}
                style={{ minHeight: 200 }}
                rowSelection={false}
                rowsPerPageOptions={[10, 20, 30]}
                components={{
                  Toolbar: GridToolbar,
                  FilterPanel: GridFilterPanel,
                }}
                slotProps={{
                  filterPanel: {
                    sx: {
                      width: "100%",          // full width responsive
                      maxWidth: "100%",
                      padding: "10px",
                      "& .MuiDataGrid-filterForm": {
                        flexDirection: "column",
                        gap: "10px",
                      },
                    },
                  },
                }}
                pagination
              />
            </>

          }

          <Modal
            open={openModalUpdate}
            onClose={handleCloseModalUpdate}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",

                width: isMobile ? 300 : 600,
                maxHeight: "100%",

                overflowY: "auto",
                overflowX: "auto",
                backgroundColor: "white",
                boxShadow: 24,
                padding: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "baseline",
                  justifyContent: "flex-end",
                  cursor: "pointer",
                  padding: "20px",
                }}
                onClick={handleCloseModalUpdate}
              >
                <img style={{ width: 20, height: 20 }} src="/Close.png" />
              </div>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "80%",
                  margin: "auto",
                }}
              >
                <Grid container spacing={2} style={{ marginBottom: 13 }}>
                  <Grid item xs={12}>
                    <TextField
                      disabled
                      id="outlined-disabled"
                      label="Current Email"
                      defaultValue={currentEmail.value}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      required
                      label=" New Email"
                      value={new_email}
                      onChange={(e) => setnewEmail(e.target.value)}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                </Grid>

                <Button
                  variant="contained"
                  onClick={() => handleUpdateButton(currentEmail.id)}
                >
                  Update
                </Button>
              </Box>
            </div>
          </Modal>
          <Modal
            open={openModalAdd}
            onClose={() => setopenModalAdd(false)}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",

                width: isMobile ? 300 : 600,
                maxHeight: "100%",

                overflowY: "auto",
                overflowX: "auto",
                backgroundColor: "white",
                boxShadow: 24,
                padding: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "baseline",
                  justifyContent: "flex-end",
                  cursor: "pointer",
                  padding: "20px",
                }}
                onClick={() => setopenModalAdd(false)}
              >
                <img style={{ width: 20, height: 20 }} src="/Close.png" />
              </div>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "80%",
                  margin: "auto",
                }}
              >
                <Grid container spacing={2} style={{ marginBottom: 13 }}>
                  <Grid item xs={12}>
                    <TextField
                      required
                      label="Email"
                      value={new_emailAdd}
                      onChange={(e) => setnewEmailAdd(e.target.value)}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                </Grid>

                <Button variant="contained" onClick={handleAddButton}>
                  Add
                </Button>
              </Box>
            </div>
          </Modal>
        </Grid>
      </Grid>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UserManagement;
